// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Checkbox from 'material-ui/Checkbox'
import Avatar               from 'material-ui/Avatar';
var Spinner = require('react-spinkit');
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import EditLead from '../editLead';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import ScheduleDemo from '../scheduleDemo';
import EditProfile from '../editProfile';
import ChildProfile from '../childProfile';
import CircularProgress from 'material-ui/CircularProgress';


const customStyles = {
 

  content : {
    top                   : '2%',
    left                  : '2%',
    right                 : '2%',
    bottom                : '2%',
   
    
  },
    overlay: {
     background: "grey",
     overflow: 'hidden',
     position: 'fixed',
     zIndex   : '100000'
    
   }

}; 




class CustomerDetails extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      dialog_open: false,
      dialog_unpause_open:false,
      active_tab: (props.match.params.page == 'booking') ? 2 : 1,
      pause_date:'',
      rejoining_date:'',
      pause_start:'',
      subscription_id:'',
      support_tickets:[],
      session_feedbacks:[],
      customer_leads:[],
      customer_bookings:[],
      customer_subscriptions:[],
      result:[],
      activities:[],
      popUpVisible:false,
      name:'',
      pause_types: {},
      pause_type: 0,
      current_homebatches:[]
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitUnpause = this.handleSubmitUnpause.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onClicked = this.onClicked.bind(this);
   
    
    
    
  }

  handleTabClick(tabIndex){
        if(tabIndex==1 ){
          this.customerLeads();
        }else if(tabIndex==2 ){
          this.customerBookings();
        }else if(tabIndex==3  ){
          this.customerSubscriptions();
          this.currentHomebatches();

        }
        else if(tabIndex==4 ){
          this.customerSupportTickets();
        }
        else if(tabIndex==5 ){
          this.customerSessionFeedbacks();
        }
        else if(tabIndex==6 ){
          this.customerAttendence();
        }
        else if(tabIndex==7 ){
          this.customerActivity();
        }





        this.setState({
            active_tab: tabIndex,
        });
    }

  

 

  closeModal() {
    this.setState({popUpVisible: false});
  }

  onClicked(e){
    console.log('name')
    console.log(e)
    this.setState({name:e, popUpVisible:true});
  }

  handleOpen = (id) => {
    this.setState({dialog_open: true});
    this.setState({subscription_id:id})
  };

  handleClose = () => {
    this.setState({dialog_open: false,dialog_unpause_open:false});
  };


  componentDidMount() {
     this.customerFulldetails();
     this.customerLeads();
     this.getPauseTypes();
      console.log('didMount leads length')
      console.log(this.state.customer_leads.length)
    //this.customerSessionFeedbacks(); 
  }


  componentWillMount(){
  }

  customerFulldetails(){
    console.log('we are here in customerFulldetails')

    const url = `${getLocationOrigin()}/customer_list/get_customer_info/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ profile_list: data.profile_list, profile_data: data.profile_data}))
       .catch(error => error);
  }
  customerLeads(id){
    var selected_id = this.state.id;
    if(id){
      selected_id = id
    }
    const url = `${getLocationOrigin()}/customer_list/get_customer_leads/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({customer_leads:data.customer_leads.leads}))
       .catch(error => error);
  }


  customerBookings(){
    const url = `${getLocationOrigin()}/customer_list/get_customer_bookings/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({customer_bookings:data.customer_bookings.bookings}))
       .catch(error => error);

  }

  customerSubscriptions(){
    const url = `${getLocationOrigin()}/customer_list/get_customer_subscriptions/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({customer_subscriptions:data.customer_subscriptions[0].subscriptions}))
       .catch(error => error);
 
  }

  getPauseTypes(){
    const url = `${getLocationOrigin()}/subscriptionpause/get_pause_types/`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({pause_types:data.pause_types}))
       .catch(error => error);
  }







  switchProfile(id, props){
    console.log('in switch profile')
    this.setState({dialog_open: false});
    
    const url = `${getLocationOrigin()}/customer_list/get_customer_info/?customer_id=${id}`;
    const options = {...defaultOptions};

    
    
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ profile_list: data.profile_list, profile_data: data.profile_data,  id: id},()=>{this.handleTabClick(this.state.active_tab)},()=>{$(".tabs").load(window.location.href+" .tabs");}))
       .catch(error => error);
  }
  customerSupportTickets(){
    const url = `${getLocationOrigin()}/customer_list/get_support_tickets/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ support_tickets: data.support_tickets}))
       .catch(error => error);

 
  }

  customerSessionFeedbacks(){
    console.log('this is customerSessionFeedbacks ')
    const url = `${getLocationOrigin()}/customer_list/get_session_feedbacks/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ session_feedbacks: data.session_feedbacks}))
       .catch(error => error);
       
 
  }
  customerAttendence(){
    console.log('this is customerAttendence ')
    const url = `${getLocationOrigin()}/customer_list/get_player_attendance/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ result: data.result}))
       .catch(error => error);
      console.log('results')
      console.log(data.result)
 
  }

  currentHomebatches(){
    console.log('this is currentHomebatches ')
    const url = `${getLocationOrigin()}/customer_list/homebatches_details/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ current_homebatches: data.current_homebatches}))
       .catch(error => error);
      console.log('results....')
      console.log(data.result)
 
  }

  customerActivity(){
    console.log('this is customerActivity ')
    const url = `${getLocationOrigin()}/customer_list/get_customer_activities/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ activities: data.activities}))
       .catch(error => error);
      console.log('activities')
      console.log(data.activities)
  }

  handleChange(event) {
    var name = event.target.name;
    if (name == 'pause_type'){
      this.setState({pause_type: event.target.value})
    }
    else if(name == 'pause_start'){
      this.setState({pause_start: event.target.value})
    }
    else if(name == 'rejoining_date'){
      this.setState({rejoining_date: event.target.value})
    }
    else{
      this.setState({pause_date: event.target.value})
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    if(this.state.pause_date){
      this.postPauseSubscription(this.state.pause_date, this.state.pause_start, this.state.pause_type, this.state.subscription_id, this.props);
      
    }
    else{
      alert("Please Enter Date")
    }
    this.currentHomebatches()
    this.customerSubscriptions()
  }

  handleSubmitUnpause(event) {
    console.log('handlesubmit....')
    console.log(event.target.name)
    event.preventDefault();
    if(this.state.rejoining_date){
      this.postUnPauseSubscription(this.state.rejoining_date, this.state.subscription_id, this.props);
      
    }
    else{
      alert("Please Enter Date")
    }

    this.currentHomebatches()
      this.customerSubscriptions()
    
  }

  postUnPauseSubscription(rejoining_date, subscription_id, props){
    this.setState({dialog_unpause_open: false});
    var date = moment(rejoining_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY/MM/DD")
    const url = `${getLocationOrigin()}/subscriptionpause/unpause_subscription/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                         'rejoining_date': date,
                         'subscription_id':subscription_id,
                       });
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(function(response){
        alert(response.Message);
        
       })
       .then(this.currentHomebatches())
       .then(this.customerSubscriptions())
       .catch(error => {
         console.log(error);
         alert(error.message);
       });
  }

  

  missedCallsms(props) {
    const url = `${getLocationOrigin()}/lead/lead_missed_call_sms/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'customer_id': this.state.id});
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){
          alert(response.message);
      })
      .catch(error => {
        console.log(error);
        console.log(error.message);
      });
  }

  postPauseSubscription(pause_date, pause_start, pause_type, subscription_id, props){
    if(pause_start == ''){
      pause_start = moment().toDate()
    }
    this.setState({dialog_open: false});
    var date = moment(pause_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
    var start_date = moment(pause_start, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
    const url = `${getLocationOrigin()}/subscriptionpause/pause_subscription/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                         'pause_date': date,
                         'pause_type': pause_type,
                         'starting_pause_date': start_date,
                         'subscription_id':subscription_id,
                       });
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(function(response){
        alert(response.Message);
       })
       .then(this.currentHomebatches())
       .then(this.customerSubscriptions())
       .catch(error => {
         console.log(error);
         alert(error.message);
       });
  }

  venueSms(props) {
    const url = `${getLocationOrigin()}/lead/send_venue_sms/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'customer_id': this.state.id});
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){
          alert(response.message);
      })
      .catch(error => {
        console.log(error);
        console.log(error.message);
      });
  }

  connectCall(mobile_no) {
    const url = `${getLocationOrigin()}/calls/connect_customer/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                                        'customer_no': mobile_no,
                                        'source':'CM'
                                          });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                     
          alert(response.message);
          // props.history.goBack();
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
    }  




  renderTabButtons(active_tab) {
      
    
      return(
                <div style={{justifyContent: 'center', padding: '1%', display: 'flex', }} className="col-md-12">
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==1)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==1) ? '' : '0 6px 4px -4px #000', width: '33%', color: (active_tab==1)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==1?'active':''}`} onClick={()=>this.handleTabClick(1)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}>Leads</span>  
                  </div>
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==2)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==2) ? '' :'0 6px 4px -4px #000', width: '33%', color: (active_tab==2)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==2?'active':''}`} onClick={()=>this.handleTabClick(2)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}> Bookings</span>
                  </div>
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==3)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==3) ? '' : '0 6px 4px -4px #000', width: '33%', color: (active_tab==3)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==3?'active':''}`} onClick={()=>this.handleTabClick(3)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}>Subscriptions</span>
                  </div> 
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==4)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==4) ? '' : '0 6px 4px -4px #000', width: '33%', color: (active_tab==4)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==4?'active':''}`} onClick={()=>this.handleTabClick(4)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}>Support tickets history</span>
                  </div>
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==5)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==5) ? '' : '0 6px 4px -4px #000', width: '33%', color: (active_tab==5)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==5?'active':''}`} onClick={()=>this.handleTabClick(5)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}>Session feedbacks history</span>
                  </div> 
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==6)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==6) ? '' : '0 6px 4px -4px #000', width: '33%', color: (active_tab==6)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==6?'active':''}`} onClick={()=>this.handleTabClick(6)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}>Attendence history</span>
                  </div>
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==7)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==7) ? '' : '0 6px 4px -4px #000', width: '33%', color: (active_tab==7)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==7?'active':''}`} onClick={()=>this.handleTabClick(7)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}>Activity history</span>
                  </div>                                                                          
                </div>
      )
    }


  render() {
    
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        onClick={this.handleSubmit}
      />,
    ];

    const unpause_actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        onClick={this.handleSubmitUnpause}
      />,
    ];
    
    return(
      <div style={styles.container}>
      { this.state.profile_data ? 
        <div className="row col-md-12 table-bordered" style={styles.table} style={{flexDirection:'row'}}>
            <div className="profile_header col-md-12 " style={{flexDirection: 'row', justifyContent: 'space-between', border: '1px solid #eee',}}>
                  <h4 style={{textAlign:'center'}}>Other Profiles</h4>
                  {
                    this.state.profile_list.map((list, index)=>(
                      <div  className="col-md-2 col9" key={index} style={{display: (list.selected == true) ? 'none': 'flex' ,flexDirection:'row', alignSelf: 'center', marginBottom: '4px', flexDirection: 'column', float: 'right'}} className="col-md-2" onClick={()=>{this.switchProfile(list.id, this.props)}}>
          
                        <Avatar size={60} src={list.photo.includes('http') ? list.photo : 'https://api.sporthood.in'+list.photo} style={{alignSelf: 'center'}}/>
                         <span style={{fontSize: '100%', fontWeight: 600, paddingTop: '1%', alignSelf: 'center' }} onClick={()=>{this.switchProfile(list.id, this.props)}}>{list.name}</span>

                      </div>))
                  }
               <div style={{flexDirection: 'column' }} onClick={(e) => this.onClicked('ChildProfile')}>   
                <button className="btn" style={{border: 'none', backgroundColor: '#fff', float: 'left', margin: '13px',marginLeft:'20px'}}>
                  <i className="fa fa-plus-circle" style={{fontSize: 'large'}}></i>
                  <span style={{fontSize: '100%', fontWeight: 600, margin: '4px'}}>Add profile</span>
                </button>
               </div>                           
            </div>  
            <div style={{border: '1px solid #eee',flexDirection:'row',display: 'flex', justifyContent: 'space-around',width:'100%'}} className="col-md-12" >

                <div className="photo_section" style={{flexDirection: 'column', display: 'flex', marginTop: '3px',width:'28%'}}>
                  <div style={{flexDirection: 'row'}}>
                    <Avatar size={90} src={this.state.profile_data[this.state.id].photo.includes('http')? this.state.profile_data[this.state.id].photo : 'https://api.sporthood.in'+this.state.profile_data[this.state.id].photo} />
               
                  </div>
                  <span style={{fontWeight: 600, paddingTop: '1%', color: '#FC427B'}}>{this.state.profile_data[this.state.id].name}</span>
                  <span style={{fontWeight: 600, paddingTop: '1%', color: '#FC427B'}}>{this.state.profile_data[this.state.id].mobile_no.slice(0,3)+'***'+this.state.profile_data[this.state.id].mobile_no.slice(6,10)}</span>
                  <div className="col-md-4" onClick={(e) => this.onClicked('EditProfile')}>
                      <div style={{backgroundColor: '#FDD60B', color: '#000',marginBottom: '1px',borderRadius: '4px', borderWidth: '0px',padding:'6px'}}>
                       Edit Profile
                    </div>
                  </div>
                </div>

                <div  style={{flexDirection: 'column', display: 'flex', marginTop: '1px',width:'35%'}}>
                    <div style={{fontSize: '90%', fontWeight: 600,  marginTop: '5px', color: (this.state.profile_data[this.state.id].customer_type) ?'#000' : '#FF0000', whiteSpace: 'nowrap',}}>
                    <span>Type:</span> <span>{this.state.profile_data[this.state.id].customer_type ? this.state.profile_data[this.state.id].customer_type : "No data"}</span></div>
                    <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px', color: (this.state.profile_data[this.state.id].email)? '#000': '#FF0000'}}>
                      <div>Email:</div> <div>{this.state.profile_data[this.state.id].email ? this.state.profile_data[this.state.id].email : "No data"}</div>
                    </div>
                    <span style={{fontSize: '90%', fontWeight: 600,  marginTop: '5px', color: (this.state.profile_data[this.state.id].date_of_birth)? '#000':'#FF0000', whiteSpace: 'nowrap',}}>DOB: {this.state.profile_data[this.state.id].date_of_birth ? this.state.profile_data[this.state.id].date_of_birth : "No data"}</span>
                    <span style={{fontSize: '90%', fontWeight: 600,  marginTop: '5px', color: (this.state.profile_data[this.state.id].gender)? '#000' : '#FF0000', whiteSpace: 'nowrap',}}>Gender: {this.state.profile_data[this.state.id].gender ? this.state.profile_data[this.state.id].gender : "No data"}</span>
                    <span style={{fontSize: '90%', fontWeight: 600,  marginTop: '5px', color: (this.state.profile_data[this.state.id].source)? '#000' : '#FF0000', whiteSpace: 'nowrap',}}>Lead Source: {this.state.profile_data[this.state.id].source ? this.state.profile_data[this.state.id].source : "No data"}</span>
                   {
                    this.state.profile_data[this.state.id].customer_type == 'Child' ?
                    <div style={{flexDirection: 'column', display: 'flex', justifyContent: 'space-between',}}>
                      <span style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600,  marginTop: '5px', color: (this.state.profile_data[this.state.id].jersey_size)? '#000':'#FF0000', whiteSpace: 'nowrap',}}>Size: {this.state.profile_data[this.state.id].jersey_size ? this.state.profile_data[this.state.id].jersey_size : "Nil"}</span>
                      <span style={{fontSize: '90%', fontWeight: 600,  marginTop: '5px',color: (this.state.profile_data[this.state.id].school)? '#000' : '#FF0000'}}>School: {this.state.profile_data[this.state.id].school ? this.state.profile_data[this.state.id].school : "Nil"}</span>
                      <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600,  marginTop: '5px',color: (this.state.profile_data[this.state.id].level.length>0)? '#000' : '#FF0000', whiteSpace: 'nowrap',}}>
                        <div>Gamelevel:</div> <div>{(this.state.profile_data[this.state.id].level.length > 0)  ? this.state.profile_data[this.state.id].level[0].game +":"+this.state.profile_data[this.state.id].level[0].game_level : "Nil"}</div>
                      </div>
                    </div>
                    :
                    <div></div>

                   }
                </div>
                
                  {
                  this.state.profile_data[this.state.id].customer_type == 'Child' &&
                    <div style={{flexDirection: 'column', display: 'flex',width:'16%', marginTop: '3px'}}>
                      <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600,color: (this.state.profile_data[this.state.id].father_name)? '#000':'#FF0000'}}>
                        <div>Father's Name:</div>
                        <div>{this.state.profile_data[this.state.id].father_name ? this.state.profile_data[this.state.id].father_name : "Nil"}</div>
                      </div>
                      <div style={{fontSize: '90%', display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px', color: (this.state.profile_data[this.state.id].father_number)? '#000':'#FF0000'}}>
                        <div>Father's  No:</div> <div>{this.state.profile_data[this.state.id].father_number ? this.state.profile_data[this.state.id].father_number : "Nil"}</div>
                      </div>
                      <div style={{fontSize: '90%', fontWeight: 600,display: 'flex',flexWrap: 'wrap', marginTop: '5px', color: (this.state.profile_data[this.state.id].mother_name)? '#000':'#FF0000'}}>
                        <div>Mothers Name:</div> <div>{this.state.profile_data[this.state.id].mother_name ? this.state.profile_data[this.state.id].mother_name : "Nil"}</div>
                      </div>
                      <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px', color: (this.state.profile_data[this.state.id].mother_number)? '#000':'#FF0000'}}>
                        <div>Mothers No:</div> <div>{this.state.profile_data[this.state.id].mother_number ? this.state.profile_data[this.state.id].mother_number : "Nil"}</div>
                      </div>
                      <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px', color: (this.state.profile_data[this.state.id].apartment)? '#000':'#FF0000'}}>
                        <div>Apartment:</div> <div>{this.state.profile_data[this.state.id].apartment ? this.state.profile_data[this.state.id].apartment : "Nil"}</div>
                      </div>
                      <span style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px', color: (this.state.profile_data[this.state.id].address)? '#000':'#FF0000' }}>Address: {this.state.profile_data[this.state.id].address ? this.state.profile_data[this.state.id].address.substring(0,70) : "Nil"}</span>
                   
                    </div>
                }
                <div  style={this.state.profile_data[this.state.id].customer_type == 'Child'? { flexDirection: 'column',  marginBottom: '2px', display: 'flex', alignItems: 'center', marginTop: '0px'}:{flexDirection: 'column',  marginBottom: '1px', display: 'flex', alignItems: 'center', marginTop: '5px'}} >
                         
                          <div >
                            
                              <button onClick={(e) => this.onClicked('EditLead')}
                              style={{
                                  backgroundColor: '#FDD60B',
                                  color: '#000',
                                  marginBottom: '1px', 
                                  borderRadius: '4px', borderWidth: '0px',padding:'6px'
                                  
                              }}>
                              Edit Lead
                            </button>
                          </div>
                          <div>
                              <button 
                              onClick={(e) => this.onClicked('ScheduleDemo')}
                              style={{
                                  backgroundColor: '#FDD60B',
                                  color: '#000',
                                  marginBottom: '1px',
                                  borderRadius: '4px', borderWidth: '0px',padding:'6px'
                              }}>
                              Schedule Demo
                            </button>
                          </div>
                          <div >
                           <button  style={{backgroundColor: '#FDD60B',color: '#000', borderColor: '#FDD60B', marginBottom: '2px',borderRadius: '4px', borderWidth: '0px',padding:'6px'}}
                            type="button" onClick={()=>this.venueSms(this.props)}>Venue SMS</button>
                          </div>
                          <div >
                           <button style={{backgroundColor: '#FDD60B', borderColor: '#FDD60B', marginBottom: '2px',borderRadius: '4px', borderWidth: '0px',padding:'6px',color: '#000'}}
                            type="button" onClick={()=>this.missedCallsms(this.props)}>Missed Call SMS</button>
                          </div>
                             <a
                                href={`https://web.whatsapp.com/send?phone=91${this.state.profile_data[this.state.id].mobile_no.slice(this.state.profile_data[this.state.id].mobile_no.length - 10)}&lang=en&text=Greetings+from+Sporthood%21%C2%A0Thanks+for+showing+interest+in+playing+football+with+Sporthood.%C2%A0%0D%0A%0D%0A*Benefits+of+playing+with+Sporthood*%0D%0A-+Skill+matched+games+held+on+daily+basis%0D%0A-+Certified+trainers+help+improve+your+game+%26+fitness%0D%0A-+Leaderboard+%26+progress+monitoring%0D%0A-+Hoods+located+across+the+city%0D%0A%0D%0AVisit+our+website+http%3A%2F%2Fbit.ly%2F2rQ5k0q+to+join+a+game+now%21%0D%0A%0D%0AOr+I+can+help+schedule+a+ONE+TIME+FREE+DEMO+for+the+same+on+your+confirmation.`}
                                target="_blank"
                                className="col-md-12"
                                style={{
                                    border: '1px solid rgb(37, 211, 102)',
                                    color: '#000',
                                    marginBottom: '1px',
                                    fontSize:'100%',
                                    width:'15vw',
                                    padding:'2%'
                                }}>

                                <i style={{fontSize:'1.9vw', color: 'rgb(37, 211, 102)',marginBottom: '2px',marginRight:'0.5vw'}} className="fa fa-whatsapp" aria-hidden="true"></i>
                                Football Welcome
                            </a>

                             <a
                                href={`https://web.whatsapp.com/send?phone=91${this.state.profile_data[this.state.id].mobile_no.slice(this.state.profile_data[this.state.id].mobile_no.length - 10)}&lang=en&text=Greetings%20from%20*Sporthood*%21%C2%A0Thanks%20for%20showing%20interest%20in%20playing%20badminton%20with%20Sporthood.%C2%A0%0A%0A*Benefits%20of%20playing%20with%20Sporthood*%0A-%20Skill%20matched%20games%20held%20on%20daily%20basis%0A-%20Certified%20trainers%20help%20improve%20your%20game%20%26%20fitness%0A-%20Leaderboard%20%26%20progress%20monitoring%0A-%20Hoods%20located%20across%20the%20city%0A%0AVisit%20our%20website%20http%3A%2F%2Fbit.ly%2F2DhKeup%20to%20join%20a%20game%20now%21%0A%0AOr%20I%20can%20help%20schedule%20a%20*ONE%20TIME%20FREE%20DEMO*%20for%20the%20same%20on%20your%20confirmation.`}
                                target="_blank"
                                className="col-md-12"
                                style={{
                                    border: '1px solid rgb(37, 211, 102)',
                                    color: '#000',
                                    marginBottom: '1px',
                                    fontSize:'100%',
                                    width:'18vw',
                                    padding:'2%'
                                }}>
                                
                                <i style={{fontSize:'1.9vw', color: 'rgb(37, 211, 102)',marginBottom: '2px',marginRight:'0.5vw'}} className="fa fa-whatsapp" aria-hidden="true"></i>
                                Badminton Welcome                               
                            </a>

                            <button className='btn btn-success' onClick={()=>{this.connectCall(this.state.profile_data[this.state.id].mobile_no)}}>
                              <i style={{fontSize:'1.9vw', color: 'white',marginBottom: '2px',marginRight:'0.5vw'}} className='fa fa-phone fa-2x' aria-hidden="true"></i>
                              Call Customer
                            </button>                            

                            <a style={{whiteSpace: 'nowrap'}}
                              href={`whatsapp://send?phone=91${this.state.profile_data[this.state.id].mobile_no.slice(this.state.profile_data[this.state.id].mobile_no.length - 10)}&lang=en&text=Greetings+from+Sporthood%21%C2%A0Thanks+for+showing+interest+in+playing+football+with+Sporthood.%C2%A0%0D%0A%0D%0A*Benefits+of+playing+with+Sporthood*%0D%0A-+Skill+matched+games+held+on+daily+basis%0D%0A-+Certified+trainers+help+improve+your+game+%26+fitness%0D%0A-+Leaderboard+%26+progress+monitoring%0D%0A-+Hoods+located+across+the+city%0D%0A%0D%0AVisit+our+website+http%3A%2F%2Fbit.ly%2F2rQ5k0q+to+join+a+game+now%21%0D%0A%0D%0AOr+I+can+help+schedule+a+ONE+TIME+FREE+DEMO+for+the+same+on+your+confirmation. `}>
                              Whatsapp Desktop App
                            </a>
                </div>
            </div>
          
          <div className="bottom_tabs col-md-12 " style={{flexDirection:'column',display:'flex', justifyContent: 'space-between', marginTop: '2px', border: '1px solid #eee',width:'100%'}}>
           <div className="col-md-12">
            {this.renderTabButtons(this.state.active_tab)}
          </div> 
          <div className="col-md-12 " style={{ justifyContent: 'space-between'}}>
          {
            (this.state.active_tab==1 ) ?
              <div className="col-md-12 " style={{ backgroundColor: '#fff'}}>
                <div >
                  {
                      this.state.customer_leads.map((lead, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', flexDirection: 'row',display: 'flex', marginBottom: '1%', padding: '1%', height: 'auto'}}>
                        <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                          <span style={{color: '#000', fontWeight: '600' }}>{lead.follow_up_date}</span>
                        </div>

                        <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{lead.buddy[0]}</span>
                        </div>

                         <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{lead.venue}</span>
                         </div>

                         <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{lead.status}</span>
                        </div>

                        <div  style={{justifyContent: 'center',marginTop: '2px',fontWeight: '600',color: '#000',width:'30%'}}>
                          {lead.comment}
                        </div>


                      </div>

                      ))
                  }
                </div>

            </div>
            :
            (this.state.active_tab == 2) ?
            <div className="col-md-12 col7" style={{flexDirection: 'column',display: 'flex', backgroundColor: '#fff'}}>
                <div>
                  {
                    this.state.customer_bookings.map((booking, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', flexDirection: 'row',display: 'flex', marginBottom: '1%', height: 'auto', padding: '1%'}}>
                        <div className="col-md-4 col7" style={{justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                        <div style={{color: '#000', fontWeight: '600',marginBottom:'0.5%'}}>{booking.fixture}</div>
                        <div style={{color: '#000', fontWeight: '600'}}>{booking.venue_display_name}</div>
                        </div>
                        
                        <div className="col-md-4 col7" style={{justifyContent: 'space-between', marginTop: '2px'}}>
                        <span style={{color: '#000', fontWeight: '600', }}>{booking.package}</span>
                        </div>
                         <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px'}}>
                            <span style={{color: '#000', fontWeight: '600'}}>{booking.date}</span>
                         </div>
                        <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px'}}>   
                           <span style={{color: '#000'}}>Status </span>
                            <span style={{color: '#000', fontWeight: '600'}}>{booking.status}</span>
                        </div>
                      </div>
                      ))
                  }
                </div>
            </div>
            :
              (this.state.active_tab == 3) ?
              <div style={{flexDirection: 'column', backgroundColor: '#fff', marginLeft: '5px', padding: '1%', display: 'flex'}}>
                <div>
                  {
                    this.state.customer_subscriptions.map((data, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', padding: '1%', flexDirection: 'column', marginBottom: '3px'}} className="col-md-12">
                        <div className="col-md-12" style={{flexDirection: 'row', display: 'flex', justifyContent: 'space-between'}}>
                        <div className="col-md-3" style={{width:'25%'}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{data.package}</span>
                        </div>
                        <div className="col-md-3" style={{width:'25%'}}>
                          <span style={{color: '#000', justifyContent: 'space-between', fontWeight: '600'}}>Sessions Left: {data.sessions_left}</span>
                        </div>
                        <div className="col-md-3" style={{width:'25%'}}>
                          <span style={{color: '#000', fontWeight: '600' }}>Start date: {data.start_date}</span>
                        </div>
                        
                        <div className="col-md-3" style={{width:'25%'}}>
                           <button  style={{backgroundColor: '#FDD60B', borderColor: '#FDD60B',  borderRadius: '4px', borderWidth: '0px',padding:'6px'}}
                            type="button" ><a href={"https://api.sporthood.in/api/v1/invoice/download/?subscription_id="+data.id}>Download</a></button>
                          </div>
                        </div>
                        <div className="col-md-12" style={{flexDirection: 'row', display: 'flex', justifyContent: 'space-between'}}>
                            <div className="col-md-3" style={{width:'25%'}}>
                            <span style={{color: '#000', alignSelf: 'center',fontWeight: '600'}}>{data.gamename} : {data.gamentypename}</span>
                            </div>
                            <div className="col-md-3" style={{width:'25%'}}>   
                            <span style={{color: '#000', justifyContent: 'space-between', fontWeight: '600'}}>Total Pause: {data.total_pause}</span>
                            </div>
                            
                            <div className="col-md-3" style={{width:'25%'}}>
                            <span style={{color: '#000', fontWeight: '600'}}>End Date: {data.end_date}</span>
                            </div>
                            <div className="col-md-3" style={{width:'25%'}}>
                           <button  style={{backgroundColor: '#FDD60B', borderColor: '#FDD60B',borderRadius: '4px', borderWidth: '0px',marginTop: '3px',padding:'6px'}}
                            type="button" ><a href={"https://api.sporthood.in/v2/cart/edit_homebatches/?subscription_id="+data.id}>Edit Homebatch</a></button>
                          </div>
                        </div>

                        <div className="col-md-12" style={{flexDirection: 'row', display: 'flex', justifyContent: 'space-between',marginBottom:'0.5%'}}>
                            <div className="col-md-3" style={{width:'25%'}}>
                              {this.state.current_homebatches[index][0] &&
                               <span style={{color: '#000', alignSelf: 'center',fontWeight: '600'}}>Venue-{this.state.current_homebatches[index][0][0]}</span> 
                              }
                            
                            </div>
                            <div className="col-md-3" style={{width:'25%'}}>   
                              <span style={{color: '#000', justifyContent: 'space-between', fontWeight: '600'}}></span>
                            </div>
                            
                            <div className="col-md-3" style={{width:'25%'}}>
                              <span style={{color: '#000', fontWeight: '600'}}></span>
                            </div>
                            <div className="col-md-3" style={{width:'25%',display:'flex',flexDirection:'column'}}>
                              {this.state.current_homebatches[index].map((data, index)=>(
                                <span style={{color: '#000', alignSelf: 'center',fontWeight: '600'}}>{index+1}-{data[1]}</span>

                              ))}
                          </div>
                        </div>

                      
                        <div className="col-md-12" style={{flexDirection: 'row', display: 'flex', justifyContent: 'space-between'}}>
                          <div className="col-md-3" style={{width:'25%'}}>   
                          <span style={{color: '#000', justifyContent: 'space-between', fontWeight: '600'}}>Amount: {data.amount}</span>
                          </div>
                          <div className="col-md-3" style={{width:'25%'}}>   
                            <span style={{color: '#000', justifyContent: 'space-between', fontWeight: '600'}}>Used Pause: {data.subscription_pause.length}</span>
                            </div>
                            <div className="col-md-3" style={{width:'25%'}}> 
                            {data.end_date < moment().format("YYYY-MM-DD")?
                              <span style={{color: '#000', justifyContent: 'space-between', fontWeight: '600'}}>Status: Expired</span>
                              :
                            <span style={{color: '#000', justifyContent: 'space-between', fontWeight: '600'}}>Status: {data.status}</span>
                            }
                            </div>
                            <div className="col-md-3" style={{width:'25%'}}>
                          {data.total_pause > -1 ?
                          <div>
                        {data.status === "active" ?
                           <button style={{backgroundColor: '#FDD60B',color:'#3c8dbc', borderColor: '#FDD60B',borderRadius: '4px', borderWidth: '0px',marginTop: '3px',padding:'6px'}}
                            type="button" onClick={()=>this.setState({dialog_open:true, subscription_id:data.id})}>Pause Subscription</button>
                            :
                            <button style={{backgroundColor: '#FDD60B',color:'#3c8dbc', borderColor: '#FDD60B',borderRadius: '4px', borderWidth: '0px',marginTop: '3px',padding:'6px'}}
                            type="button" onClick={()=>this.setState({dialog_unpause_open:true, subscription_id:data.id})} >Unpause Subscription</button>
                        }

                          <div>
                            {this.state.subscription_id === data.id &&
                          <Dialog
                                actions={actions}
                                modal={false}
                                open={this.state.dialog_open}
                                onRequestClose={this.handleClose}
                                style ={{zIndex:'10000000'}}

                              >
                                <div>
                                  <div style={styles.items} className="col-md-12">
                                    <div style={styles.item_header} className="col-md-6">
                                      Reason of Pause
                                    </div>
                                    <select name="pause_type" className="col-md-6" style={styles.item_body} onChange={this.handleChange} value={this.state.pause_type}>
                                      { 
                                         Object.keys(this.state.pause_types).map((key,index)=>(
                                           <option key={key} value={key}>{this.state.pause_types[key]}</option>
                                          ))
                                      }
                                    </select>
                                  </div>
                                  <div style={styles.items} className="col-md-12">
                                    <div style={styles.item_header} className="col-md-6">
                                      Date from you want to Pause (DD/MM/YYYY)
                                    </div>
                                    <input type="text" style={styles.input} name="pause_start" className="required"
                                      value={this.state.pause_start} onChange={this.handleChange}/>
                                  </div>
                                  <div style={styles.items} className="col-md-12">
                                    <span style={{color:'red',fontSize:'80%',paddingLeft:'1%'}}>Leave Blank if start from current day </span>
                                  </div>
                                  <div style={styles.items} className="col-md-12">
                                    <div style={styles.item_header} className="col-md-6">
                                      Date till you want to Pause (DD/MM/YYYY)
                                    </div>
                                    <input type="text" style={styles.input} name="pause_date" className="required"
                                      value={this.state.pause_date} onChange={this.handleChange}/>
                                  </div>
                                </div>
                              </Dialog>
                            }
                            </div>
                            </div>
                            :
                            <button style={{backgroundColor: '#FDD60B', borderColor: '#FDD60B',borderRadius: '4px', borderWidth: '0px',marginTop: '3px',padding:'6px'}}
                            type="button" onClick={()=>alert("Can't Pause Subscription")}>Pause Subscription</button>

                          } 


                          </div>
                            {this.state.dialog_unpause_open == true?
                            <Dialog
                                  actions={unpause_actions}
                                  modal={false}
                                  open={this.state.dialog_unpause_open}
                                  onRequestClose={this.handleClose}
                                  style ={{zIndex:'10000000'}}

                                >
                                  <div>
                                    
                                    <div style={styles.items} className="col-md-12">
                                      <div style={styles.item_header} className="col-md-6">
                                        Rejoining date (YYYY/MM/DD)
                                      </div>
                                      <input type="text" style={styles.input} name="rejoining_date" className="required"
                                        value={this.state.rejoining_date} onChange={this.handleChange}/>
                                    </div>
                                    
                                  </div>
                                </Dialog>
                                :
                                ''


                            }
                        </div>
                      </div>
                      ))
                  }
                </div>
                
            </div>
            :
            (this.state.active_tab == 4) ?
            <div style={{flexDirection: 'column', backgroundColor: '#fff', padding: '1%', display: 'flex',height:'auto'}}>
                  {

                    this.state.support_tickets.map((support, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', flexDirection: 'row',display:'flex', marginBottom: '1%', height: 'auto', padding: '1%'}}>

                        <div className="col-md-2" style={{justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{support.created_on}</span>
                        </div>
                        
                        <div className="col-md-2" style={{justifyContent: 'space-between', marginTop: '2px'}}>   
                            <span style={{color: '#000', fontWeight: '600'}}>{support.status_display}</span>
                        </div>
                         <div className="col-md-2" style={{justifyContent: 'space-between', marginTop: '2px'}}>   
                            <span style={{color: '#000',fontWeight: '600'}}>{support.comment}</span>
                        </div>
                        <div className="col-md-4" style={{ justifyContent: 'space-between', marginTop: '2px'}}>
                          <span style={{color: '#000', fontWeight: '600', }}>{support.content}</span>
                        </div>

                        <div className="col-md-2" style={{justifyContent: 'space-between', marginTop: '2px'}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{support.ticket_type_display}</span>
                        </div>
                      </div>
                      ))
                  }
            </div>
            :
            (this.state.active_tab == 5) ?
            <div className="col-md-12" style={{flexDirection: 'column', backgroundColor: '#fff', padding: '1%', display: 'flex'}}>
                <div>
                  {

                    this.state.session_feedbacks.map((session, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', flexDirection: 'row', display:'flex', marginBottom: '1%', height: 'auto', padding: '1%'}}>

                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                          <span style={{color: '#000',fontWeight: '600'}}>{session.created_on}</span>
                        </div>
                        
                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>   
                            <span style={{color: '#000', fontWeight: '600'}}>{session.rating}</span>
                        </div>
                         <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>   
                            <span style={{color: '#000',fontWeight: '600'}}>{session.comment}</span>
                        </div>
                        <div className="col-md-4" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>
                          <span style={{color: '#000', fontWeight: '600', }}>{session.admin_comment}</span>
                        </div>

                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{session.status}</span>
                        </div>
                      </div>
                      ))
                  }
                </div>
            </div>
            :
            (this.state.active_tab == 6) ?
            <div className="col-md-12" style={{flexDirection: 'column', backgroundColor: '#fff', marginLeft: '3px', padding: '1%', display: 'flex'}}>
              { this.state.result.bookings.length > 0 ?
                <div>
                  {
                    this.state.result.bookings.map((attendance, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', flexDirection: 'row', marginBottom: '1%',display: 'flex', height: 'auto', padding: '1%'}}>

                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{attendance.status}</span>
                        </div>
                         <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{this.state.result.attendance_percentage}</span>
                        </div>
                        
                         
                      </div>
                      ))
                  }
                </div>
                :
                ""
              }
            </div>
            :
            (this.state.active_tab == 7) ?
            <div className="col-md-12" style={{flexDirection: 'column', backgroundColor: '#fff', marginLeft: '3px', padding: '1%', display: 'flex'}}>
              {this.state.activities.length > 0 ?
                <div>
                  {

                    this.state.activities.map((activity, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', flexDirection: 'column', marginBottom: '1%', height: '80px', padding: '1%'}}>

                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                          <span style={{color: '#000', fontSize: '15px', fontWeight: '600'}}>{activity.created_on}</span>
                        </div>
                        
                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                          <span style={{color: '#000', fontSize: '15px', fontWeight: '600'}}>{activity.updated_on}</span>
                        </div>

                        {/*<div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>   
                            <span style={{color: '#000',  fontSize: '15px', fontWeight: '600'}}>{activity.path}</span>
                        </div>*/}
                         
                        
                      </div>
                      ))
                  }
                  </div>
                  :
                  ""
                }
                
            </div>
            :
            <div style={{height:500}}>
                    <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}><CircularProgress /></div>
                  </div>
                }

          </div>
          </div>

          </div>
          :
         <div className="loading-overlay"><Spinner name="ball-grid-pulse" color="darkturquoise"/></div>


      }
          { this.state.popUpVisible ?
            <div >

             <Modal
                isOpen={this.state.popUpVisible}
                onRequestClose={this.closeModal}
                style={customStyles}

              >
                <button className ="btn" onClick={this.closeModal} style={{color:'red',position:'absolute',right:-15,top:-5}}><i className="fa fa-close fa-2x" ></i></button>
                  {(this.state.name== 'EditLead')?
                    <EditLead match={{"params":{"id":this.state.id}}}/>
                  : 
                  ((this.state.name == 'ScheduleDemo')?
                  <ScheduleDemo match={{"params":{"id":this.state.id}}}/>
                  :
                  (this.state.name == 'EditProfile') ?
                  <EditProfile match={{"params":{"id":this.state.id}}}/>
                  :
                  <ChildProfile match={{"params":{"id":this.state.id}}}/>
                  )
                  
                }
                
              </Modal>
            </div>
            :
            ""
          }
      </div>
    );
  }
}

export default CustomerDetails;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/customerDetails/index.js